import { buildChartTheme } from "@visx/xychart";

const AXIS_LABEL_COLOR = "rgba(194,214,255,0.4)";
const GRID_COLOR = "rgba(194,214,255,0.08)";

const AXIS_LABEL_STYLE = {
  fill: AXIS_LABEL_COLOR,
  fontSize: 11,
  fontFamily: "var(--f-mono, ui-monospace, SFMono-Regular, monospace)",
  fontWeight: 400,
  lineHeight: 1,
} as const;

export function buildHedgeChartTheme(primary: string) {
  return buildChartTheme({
    backgroundColor: "transparent",
    colors: [primary],
    gridColor: GRID_COLOR,
    gridColorDark: GRID_COLOR,
    gridStyles: { strokeDasharray: "4 4" },
    tickLength: 0,
    svgLabelSmall: AXIS_LABEL_STYLE,
    svgLabelBig: AXIS_LABEL_STYLE,
  });
}
